import { lazy, Suspense } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

/**
 * amCharts 5 is ~550 kB minified. These three charts are the only ones reachable
 * from the eagerly loaded app shell, so importing them directly pulls the whole
 * library into the entry bundle. Loading them through React.lazy keeps amCharts
 * in its own chunk that is fetched only when a chart is actually rendered.
 *
 * Import charts from here rather than from their component files directly.
 */

const ChartFallback = ({ minHeight }) => (
  <Box sx={{ width: "100%", minHeight, flexShrink: 0 }} />
);

ChartFallback.propTypes = {
  minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const withChartSuspense = (Component, getMinHeight) => {
  const LazyChart = (props) => (
    <Suspense fallback={<ChartFallback minHeight={getMinHeight(props)} />}>
      <Component {...props} />
    </Suspense>
  );
  return LazyChart;
};

export const DonutChart = withChartSuspense(
  lazy(() => import("./DonutChart")),
  (props) => props.height ?? 500
);

export const CommonAreaChart = withChartSuspense(
  lazy(() => import("./CommonAreaChart")),
  () => 250
);

export const WealthChart = withChartSuspense(
  lazy(() => import("./WealthChart")),
  (props) => props.size ?? 250
);
